export default __webpack_public_path__ + "95ea0fce91e508bb876129847958eb9e.svg";